var _toConsumableArray = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var base58 = require('base-58');

var _require = require('../crypto'),
    sha256d = _require.sha256d;

var _require2 = require('./constant'),
    SERVER_IDENTITY_KEY_HEX_PREFIX_MAP = _require2.SERVER_IDENTITY_KEY_HEX_PREFIX_MAP,
    SERVER_IDENTITY_KEY_PREFIXES = _require2.SERVER_IDENTITY_KEY_PREFIXES;

function isValidSk1(key) {
  return isValidIdentityKey(key, 'sk1');
}

function isValidSk2(key) {
  return isValidIdentityKey(key, 'sk2');
}

function isValidSk3(key) {
  return isValidIdentityKey(key, 'sk3');
}

function isValidSk4(key) {
  return isValidIdentityKey(key, 'sk4');
}

function isValidIdentityKey(key, prefixes) {
  if (typeof key !== 'string') {
    return false;
  }

  var validPrefixes = getValidPrefixes(prefixes);
  var bytes;

  if (validPrefixes.has(key.slice(0, 3))) {
    bytes = Buffer.from(base58.decode(key));
  } else {
    var validHexPrefixes = new Set(_toConsumableArray(validPrefixes).map(function (p) {
      return SERVER_IDENTITY_KEY_HEX_PREFIX_MAP[p];
    }));

    if (validHexPrefixes.has(key.slice(0, 6))) {
      bytes = Buffer.from(key, 'hex');
    } else {
      return false;
    }
  }

  if (bytes.length !== 39) {
    return false;
  }

  var checksum = sha256d(bytes.slice(0, 35)).slice(0, 4);

  if (checksum.equals(bytes.slice(35, 39))) {
    return true;
  }

  return false;
}

function getValidPrefixes(prefixes) {
  if (!prefixes) {
    return SERVER_IDENTITY_KEY_PREFIXES;
  } else if (typeof prefixes === 'string') {
    return new Set([prefixes]);
  } else if (Array.isArray(prefixes)) {
    return new Set(prefixes);
  } else {
    throw new Error('Invalid prefixes');
  }
}

function isValidServerIdentityChainId(identityChainId) {
  return typeof identityChainId === 'string' && identityChainId.length === 64 && identityChainId.startsWith('888888');
}

module.exports = {
  isValidSk1: isValidSk1,
  isValidSk2: isValidSk2,
  isValidSk3: isValidSk3,
  isValidSk4: isValidSk4,
  isValidIdentityKey: isValidIdentityKey,
  isValidServerIdentityChainId: isValidServerIdentityChainId
};